<template>
  <a-layout>
    <a-tabs v-model="activeKey" style="margin-top: -4px">
      <a-tab-pane key="unstagedTable" :tab="$t('tab.unStage')" style="margin-top: -14px">
        <unstaged-table ref="unstagedTable"/>
      </a-tab-pane>
      <a-tab-pane key="unreviewedTable" :tab="$t('tab.unReview')" forceRender style="margin-top: -14px">
        <unreviewed-table ref="unreviewedTable"/>
      </a-tab-pane>
      <a-space v-if="activeKey === 'unstagedTable'" slot="tabBarExtraContent">
        <a-button type="primary" @click="getData">{{ $t('button.refresh') }}</a-button>
        <a-button type="primary" @click="stage">{{ $t('button.stage') }}</a-button>
      </a-space>
      <a-space v-else slot="tabBarExtraContent">
        <a-button type="primary" @click="getData">{{ $t('button.refresh') }}</a-button>
        <a-button type="primary" @click="review">{{ $t('button.review') }}</a-button>
      </a-space>
    </a-tabs>
  </a-layout>
</template>
<script>
  import UnstagedTable from '@/views/outbound/wave_stage/UnstagedTable.vue'
  import UnreviewedTable from '@/views/outbound/wave_stage/UnreviewedTable.vue'

  export default {
    name: 'WaveStage',
    components: {UnstagedTable, UnreviewedTable},
    data() {
      return {
        activeKey: 'unstagedTable'
      }
    },
    watch: {
      activeKey: {
        handler() {
          this.getData()
        }
      }
    },
    methods: {
      getData() {
        this.$refs[this.activeKey].getData()
      },
      stage() {
        this.$refs.unstagedTable.stage()
      },
      review() {
        this.$refs.unreviewedTable.review()
      }
    }
  }
</script>